(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-produits-moteurs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (root.dataset.vmvrInit === '1') return;
      root.dataset.vmvrInit = '1';

      var brandTabs = root.querySelectorAll('[data-vmvr-brand-tab]');
      var panels    = root.querySelectorAll('[data-vmvr-panel]');

      brandTabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var brandId = tab.getAttribute('data-vmvr-brand-tab');

          brandTabs.forEach(function(t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function(p) {
            var active = p.getAttribute('data-vmvr-panel') === brandId;
            p.classList.toggle('is-active', active);
            if (active) {
              p.removeAttribute('hidden');
            } else {
              p.setAttribute('hidden', '');
            }
          });
        });
      });

      panels.forEach(function(panel) {
        var typeTabs = panel.querySelectorAll('[data-vmvr-type]');
        var cards    = panel.querySelectorAll('[data-vmvr-card]');

        typeTabs.forEach(function(t) {
          t.addEventListener('click', function() {
            var type = t.getAttribute('data-vmvr-type');

            typeTabs.forEach(function(x) {
              var active = x === t;
              x.classList.toggle('is-active', active);
              x.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            cards.forEach(function(card) {
              var cardType = card.getAttribute('data-product-type');
              var show = (type === 'all') || (cardType === type);
              if (show) {
                card.removeAttribute('hidden');
              } else {
                card.setAttribute('hidden', '');
              }
            });
          });
        });
      });
    }

    document.querySelectorAll('[data-vmvr-root]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target.querySelector('[data-vmvr-root]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vt-reparation-etapes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || window.customElements.get('vtrp-video')) return;

    class VtrpVideo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.vtrpReady) return;
        this.dataset.vtrpReady = '1';

        var id = (this.dataset.videoId || '').trim();
        var hosted = this.querySelector('template[data-vtrp-hosted]');
        if (!id && !hosted) return;
        var base = 'https://i.ytimg.com/vi/' + encodeURIComponent(id) + '/';

        var thumb = id ? this.querySelector('img[data-yt]') : null;
        if (thumb) {
          var swapped = false;
          var useFallback = function () {
            if (swapped) return;
            swapped = true;
            thumb.src = base + 'hqdefault.jpg';
            thumb.classList.add('vtrp__poster-img--4x3');
          };
          var check = function () {
            if (thumb.naturalWidth > 0 && thumb.naturalWidth <= 120) useFallback();
          };
          if (thumb.complete) {
            if (thumb.naturalWidth === 0) useFallback(); else check();
          } else {
            thumb.addEventListener('load', check, { once: true });
            thumb.addEventListener('error', useFallback, { once: true });
          }
        }

        var btn = this.querySelector('button.vtrp__poster');
        if (!btn) return;
        var self = this;
        btn.addEventListener('click', function () {
          if (hosted) {
            var video = hosted.content.querySelector('video');
            if (!video) return;
            video = video.cloneNode(true);
            video.setAttribute('title', self.dataset.title || 'Vidéo');
            self.replaceChildren(video);
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
            video.focus();
            return;
          }
          var frame = document.createElement('iframe');
          frame.className = 'vtrp__iframe';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
          frame.title = self.dataset.title || 'Vidéo YouTube';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.setAttribute('allowfullscreen', '');
          self.replaceChildren(frame);
          frame.focus();
        }, { once: true });
      }
    }

    window.customElements.define('vtrp-video', VtrpVideo);
  })();

  } catch(e) { console.error(e); }
})();
})();
